import {
  compileTemplate,
  extractTemplateVariables,
  IExtendableDto,
  Log,
  SHOWN_PASSENGER_NAMES_LENGTH,
} from "@ryde/shared";

export const getDriversNames = (drivers: IExtendableDto[]): string =>
  drivers
    .slice(0, SHOWN_PASSENGER_NAMES_LENGTH)
    .map(e => e.name ?? "")
    .filter(name => name)
    .join(", ");

export const getPreviewMessage = (
  message: string,
  drivers: IExtendableDto[],
): string => {
  const driver = drivers?.[0];

  if (message && driver) {
    try {
      return compileTemplate(message, driver);
    } catch (err) {
      Log.error(`Error compiling template: ${message}`, err);

      const invalidKeys = extractTemplateVariables(message)?.filter(
        key => !(key in driver),
      );

      if (invalidKeys?.length > 0) {
        Log.error(`Invalid template: ${invalidKeys.join(", ")}`);
      }
    }
  }

  return message ?? "";
};
